import KitCard from '~/components/Kit/Card';
import ProductCardAlternate from '~/components/Product/Card/Alternate';
import VariantCard from '~/components/Product/VariantCard';
import BundleCard from '~/components/Bundle/Card';
import { Image } from '~/types';

type Item =
  | Queries.BundleCardFragment
  | Queries.KitCardFragmentFragment
  | Queries.ProductCardFragmentFragment
  | Queries.VariantCardFragmentFragment;

type Props = {
  item: Item;
  collectionSlug?: string;
  isFeaturedCard: boolean;
  cardDirection: boolean | null;
  fromProductSection: boolean;
  bgColor?: string;
  colorSelect?: boolean;
  renderPrice?: boolean;
  mainImage: Image;
  featuredImage: Image;
};

const KitVariantProductCard = ({
  item,
  collectionSlug,
  isFeaturedCard,
  cardDirection,
  fromProductSection,
  bgColor,
  ...rest
}: Props) => {
  if (isProduct(item))
    return (
      <ProductCardAlternate
        cardDirection={cardDirection}
        isFeatured={fromProductSection ? false : isFeaturedCard}
        bgColor={bgColor ?? 'cloud'}
        collectionSlug={collectionSlug}
        product={item}
        {...rest}
      />
    );
  if (isKit(item))
    return (
      <KitCard
        kit={item}
        isFeatured={fromProductSection ? false : isFeaturedCard}
        cardDirection={cardDirection}
        bgColor={bgColor ?? 'cloud'}
        collectionSlug={collectionSlug}
        {...rest}
      />
    );
  if (isBundle(item)) {
    return (
      <BundleCard
        bundle={item}
        isFeatured={fromProductSection ? false : isFeaturedCard}
        cardDirection={cardDirection}
        bgColor={bgColor ?? 'cloud'}
        collectionSlug={collectionSlug}
        {...rest}
      />
    );
  }
  if (isVariant(item))
    return (
      <VariantCard
        variant={item}
        isFeatured={fromProductSection ? false : isFeaturedCard}
        cardDirection={cardDirection}
        collectionSlug={collectionSlug}
        bgColor={bgColor ?? 'cloud'}
        {...rest}
      />
    );
  return null;
};

export default KitVariantProductCard;

const isKit = (item: Item): item is Queries.KitCardFragmentFragment => /kit/i.test(item?.__typename);
const isBundle = (item: Item): item is Queries.BundleCardFragment => /bundle/i.test(item?.__typename);
const isProduct = (item: Item): item is Queries.ProductCardFragmentFragment => /product/i.test(item?.__typename);
const isVariant = (item: Item): item is Queries.VariantCardFragmentFragment => /variant/i.test(item?.__typename);
